export default "__VITE_ASSET__DvcOeBPc__"